export enum Page {
    HOME = "/",
    FLUIDNC_HOME = "/Arabesque",
    FLUIDNC_TERMINAL = "/Arabesque/terminal",
    FLUIDNC_INSTALLER = "/Arabesque/install",
    FLUIDNC_FILEBROWSER = "/Arabesque/files",
    FLUIDNC_CONFIGURATION = "/Arabesque/configuration",
    FLUIDNC_WIFI = "/Arabesque/wifi",
    FLUIDNC_CALIBRATE = "/Arabesque/calibrate",
    FLUIDNC_STACKTRACE_DECODER = "/Arabesque/stacktrace",
    FLUIDNC_CONFIG_VALIDATION = "/config"
}

export default Page;
